var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4752 18.1928L23.9124 18.6419V17.1361V15.2102V14.5966L23.3921 14.2715L16.2088 9.78188V5.09921C16.2088 3.68857 15.068 2.54776 13.6573 2.54776C12.2467 2.54776 11.1059 3.68857 11.1059 5.09921V9.78188L3.92255 14.2715L3.40225 14.5966V15.2102V17.1361V18.6419L4.83948 18.1928L11.1059 16.2345V19.4715L9.62277 20.5838L9.17996 20.9159V21.4694V22.9138V24.3815L10.5911 23.9783L13.6573 23.1022L16.7235 23.9783L18.1347 24.3815V22.9138V21.4694V20.9159L17.6919 20.5838L16.2088 19.4715V16.2345L22.4752 18.1928Z",
    stroke: "#969696",
    strokeWidth: 2.21406
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlights);
export default __webpack_public_path__ + "static/media/flights.5f089ff3ceac9156c74bc8bd33faa8a0.svg";
export { ForwardRef as ReactComponent };